{
  "name": "entrarit-web",
  "version": "2.0.11",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-dev": "ng build --configuration development && npm run copy-htaccess",
    "build-prod": "ng build --configuration production && npm run copy-htaccess",
    "copy-htaccess": "cp .htaccess dist/entrarit-web/.htaccess",
    "deploy": "npm run build-prod",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-brands-svg-icons": "^6.7.2",
    "@fortawesome/free-regular-svg-icons": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "^2.11.8",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "bootstrap": "^5.3.3",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^19.0.0",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@angular/localize": "^21.2.18",
    "@types/node": "^22.10.2",
    "@types/qrcode": "^1.5.6",
    "jsdom": "^29.1.1",
    "listr2": "9.0.5",
    "typescript": "~5.9.3",
    "vitest": "^4.0.8"
  },
  "overrides": {
    "@hono/node-server": "2.0.10"
  }
}
